// 模拟后端动态生成路由
import { defineFakeRoute } from "vite-plugin-fake-server/client";

const list = [
  {
    id: 1,
    phoneNumber: "13800138000",
    username: "小明",
    pfRole: 0,
    createTime: "2023-01-01",
    pfAdminStatus: 1,
    enterpriseName: "杭州慧经盈智能科技有限公司"
  },
  {
    id: 2,
    phoneNumber: "13800138001",
    username: "小红",
    pfRole: 1,
    createTime: "2023-02-01",
    pfAdminStatus: 0,
    enterpriseName: "杭州慧经盈智能科技有限公司"
  },
  {
    id: 3,
    phoneNumber: "13800138002",
    username: "小强",
    pfRole: 2,
    createTime: "2023-03-01",
    pfAdminStatus: 1,
    enterpriseName: "杭州慧经盈智能科技有限公司"
  }
];

export default defineFakeRoute([
  {
    url: "/demo/demoPlatform/getList",
    method: "get",
    response: () => {
      return {
        error: false,
        code: 0,
        data: list
      };
    }
  },
  {
    url: "/demo/demoPlatform/add",
    method: "post",
    response: () => {
      return {
        error: false,
        code: 0,
        data: null
      };
    }
  },
  {
    url: "/demo/demoPlatform/del",
    method: "delete",
    response: () => {
      return {
        error: false,
        code: 0,
        data: null
      };
    }
  },
  {
    url: "/demo/demoPlatform/put",
    method: "put",
    response: () => {
      return {
        error: false,
        code: 0,
        data: null
      };
    }
  }
]);
